/**
 * Reads a value the user can set from the URL or localStorage, e.g.
 * `?userImpersonation=<id>`. Dependency-free so the new shell can use it via
 * `useUserImpersonation` without pulling in the legacy SigV4/Amplify client
 * in `@/utilities/api` (MAM-1011).
 *
 * A query parameter wins and is persisted to localStorage; an empty one
 * clears the stored value. Without one, the stored value is returned.
 */
export const lookupInBrowserByKey = (key: string): string | null => {
  const query = new URL(window.location.href).searchParams.get(key)
  if (query !== null) {
    if (query === '') {
      localStorage.removeItem(key)
      return null
    }
    localStorage.setItem(key, query)
    return query
  }

  return localStorage.getItem(key)
}
